import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import CalendarV2 from "../../SubscriptionPageV2/CalendarV2";
import { useScreenWidth } from "../../SubscriptionPageV2/hooks";
import BottomBar from "../../common/BottomBar";
import DrawerComponent from "../../common/DrawerComponent";
import Eyebrow from "../../common/Eyebrow";
import H3Font from "../../common/H3Font";
import SmallFont from "../../common/SmallFont";
import styles from "./styles.module.scss";
import { useSelector } from "react-redux";
const ChangeBillDateDrawer = ({ dates, changeDate, toggleDrawer, openDrawer, currentOrderDate, submit, }) => {
    const hasSubscription = useSelector((state) => state.user.has_subscription);
    const isMobile = useScreenWidth() < 1008;
    const [newOrderDate, setNewOrderDate] = React.useState("");
    const formatDay = (date) => {
        return Number(date) < 10 ? "0" + date : date;
    };
    const onChangeDate = (date) => {
        changeDate(date);
        setNewOrderDate(`${formatDay(date.getMonth() + 1)}/${formatDay(date.getDate())}`);
    };
    useEffect(() => {
        const newDate = dates.minDate;
        setNewOrderDate(`${formatDay(newDate.getMonth() + 1)}/${formatDay(newDate.getDate())}`);
    }, []);
    return (_jsxs(DrawerComponent, { crossButton: true, extraClassName: styles.drawer, anchor: isMobile ? "bottom" : "right", open: openDrawer, toggleDrawer: toggleDrawer, children: [_jsxs("div", { className: styles.content, children: [_jsx(H3Font, { fontWeight: 400, children: "Select your order date" }), _jsxs(SmallFont, { children: ["Your order date must be before", " ", formatDay(dates.maxDate.getMonth() + 1) +
                                "/" +
                                formatDay(dates.maxDate.getDate()), " ", "to redeem this promotion."] }), hasSubscription && (_jsxs(Eyebrow, { children: ["current order date: ", currentOrderDate] })), newOrderDate && _jsxs(Eyebrow, { children: ["New order date: ", newOrderDate] }), _jsx("div", { className: styles.calendar_wrapper, children: _jsx(CalendarV2, { year: dates.year, month: dates.month, day: dates.day, minDate: dates.minDate, maxDate: dates.maxDate, callBack: onChangeDate }) })] }), _jsx(BottomBar, { extraClassName: styles.bottom_bar, isRounded: true, onSave: submit, submitLabel: "save and add to box", disabledSave: newOrderDate == "" })] }));
};
export default ChangeBillDateDrawer;
